import React, { useEffect, useState } from "react";
import { Plus, Trash2, Pencil, X, Upload, ExternalLink } from "lucide-react";
import {
  adminListBanners,
  adminCreateBanner,
  adminUpdateBanner,
  adminDeleteBanner,
  uploadFile,
  fileUrl,
} from "../../api";

const SLOTS = [
  { key: "sidebar-top", label: "Sidebar alta (homepage)" },
  { key: "mid-page", label: "Mid-page (tra le news)" },
  { key: "sidebar-bottom", label: "Sidebar bassa (homepage)" },
  { key: "article-inline", label: "Dentro l'articolo" },
];

const slotLabel = (k) => SLOTS.find((s) => s.key === k)?.label || k;
const empty = { id: null, slot: "sidebar-top", image: "", link: "", active: true };

const BannerManager = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = async () => {
    try {
      setItems(await adminListBanners());
    } catch (e) {
      setItems([]);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const { url } = await uploadFile(file);
      set("image", url);
    } catch (err) {
      setMsg("Errore upload immagine");
    } finally {
      setBusy(false);
    }
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.image) {
      setMsg("Carica un'immagine per il banner");
      return;
    }
    setBusy(true);
    setMsg("");
    const body = { slot: form.slot, image: form.image, link: form.link, active: form.active };
    try {
      if (form.id) await adminUpdateBanner(form.id, body);
      else await adminCreateBanner(body);
      setForm(null);
      await load();
    } catch (err) {
      setMsg("Errore nel salvataggio");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (b) => {
    if (!window.confirm("Eliminare questo banner?")) return;
    await adminDeleteBanner(b.id);
    await load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-serif-display text-2xl text-sq-navy">Banner pubblicitari</h2>
          <p className="text-sm text-gray-500">Formato 300 × 250 · {items.length} banner</p>
        </div>
        {!form && (
          <button
            onClick={() => setForm({ ...empty })}
            className="flex items-center gap-2 bg-sq-orange hover:bg-sq-orange-dark transition-colors text-white px-4 py-2.5 rounded-sm text-sm font-medium"
          >
            <Plus size={16} /> Nuovo banner
          </button>
        )}
      </div>

      {msg && <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-sm px-3 py-2">{msg}</div>}

      {form && (
        <form onSubmit={save} className="bg-white border border-sq rounded-md p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <h3 className="font-medium text-sq-navy">{form.id ? "Modifica banner" : "Nuovo banner"}</h3>
            <button type="button" onClick={() => setForm(null)} className="text-gray-400 hover:text-sq-navy">
              <X size={20} />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-medium text-sq-navy mb-1">Posizione</label>
              <select
                value={form.slot}
                onChange={(e) => set("slot", e.target.value)}
                className="w-full border border-sq rounded-sm px-3 py-2.5 text-sm outline-none bg-white"
              >
                {SLOTS.map((s) => (
                  <option key={s.key} value={s.key}>
                    {s.label}
                  </option>
                ))}
              </select>

              <label className="block text-sm font-medium text-sq-navy mb-1 mt-4">Link di destinazione (URL)</label>
              <input
                value={form.link}
                onChange={(e) => set("link", e.target.value)}
                placeholder="https://sponsor.example.com"
                className="w-full border border-sq rounded-sm px-3 py-2.5 text-sm outline-none focus:border-sq-orange"
              />

              <label className="flex items-center gap-2 text-sm text-sq-navy cursor-pointer mt-4">
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={(e) => set("active", e.target.checked)}
                  className="w-4 h-4 accent-orange-500"
                />
                Attivo (visibile sul sito)
              </label>
            </div>

            <div>
              <label className="block text-sm font-medium text-sq-navy mb-1">Immagine banner (300 × 250)</label>
              <label className="flex items-center gap-2 border border-sq rounded-sm px-3 py-2 text-sm cursor-pointer hover:border-sq-orange w-fit">
                <Upload size={14} /> Carica immagine
                <input type="file" accept="image/*" onChange={onUpload} className="hidden" />
              </label>
              <div className="mt-3 border border-dashed border-sq rounded-sm flex items-center justify-center bg-sq-light" style={{ width: 300, height: 250 }}>
                {form.image ? (
                  <img src={fileUrl(form.image)} alt="" className="object-cover rounded-sm" style={{ width: 300, height: 250 }} />
                ) : (
                  <span className="text-xs text-gray-400">Anteprima 300 × 250</span>
                )}
              </div>
            </div>
          </div>

          <div className="flex gap-3 mt-6">
            <button
              type="submit"
              disabled={busy}
              className="bg-sq-orange hover:bg-sq-orange-dark transition-colors text-white px-5 py-2.5 rounded-sm text-sm font-medium disabled:opacity-60"
            >
              {busy ? "Salvataggio..." : "Salva banner"}
            </button>
            <button
              type="button"
              onClick={() => setForm(null)}
              className="border border-sq text-sq-navy px-5 py-2.5 rounded-sm text-sm hover:bg-sq-light"
            >
              Annulla
            </button>
          </div>
        </form>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((b) => (
          <div key={b.id} className="bg-white border border-sq rounded-md overflow-hidden">
            <img src={fileUrl(b.image)} alt="" className="w-full object-cover" style={{ height: 200 }} />
            <div className="p-4">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-sq-navy">{slotLabel(b.slot)}</span>
                <span className={`text-[10px] px-2 py-0.5 rounded ${b.active ? "bg-emerald-50 text-emerald-600" : "bg-gray-100 text-gray-500"}`}>
                  {b.active ? "Attivo" : "Disattivo"}
                </span>
              </div>
              {b.link && (
                <a href={b.link} target="_blank" rel="noopener noreferrer" className="text-xs text-sq-orange flex items-center gap-1 mt-1 truncate">
                  <ExternalLink size={11} /> {b.link}
                </a>
              )}
              <div className="flex gap-2 mt-3">
                <button
                  onClick={() => setForm({ id: b.id, slot: b.slot, image: b.image, link: b.link || "", active: b.active })}
                  className="flex items-center gap-1 text-xs border border-sq rounded-sm px-2.5 py-1.5 hover:border-sq-orange"
                >
                  <Pencil size={12} /> Modifica
                </button>
                <button
                  onClick={() => remove(b)}
                  className="flex items-center gap-1 text-xs border border-sq rounded-sm px-2.5 py-1.5 text-red-600 hover:bg-red-50"
                >
                  <Trash2 size={12} /> Elimina
                </button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && !form && (
          <div className="col-span-full text-center text-gray-500 text-sm py-10 border border-dashed border-sq rounded-md">
            Nessun banner caricato. I 3 spazi 300×250 mostrano un placeholder finché non carichi un banner.
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerManager;
